import React from 'react';
import { FormControl, Select, MenuItem, Typography, Box, useTheme, alpha } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { useYear } from '../../context/YearContext';

/**
 * Inline year picker designed for individual page headers.
 * Reads/writes the shared year via YearContext.
 * Compact: icon + dropdown, no label needed.
 */
const PageYearSelector = ({ sx = {}, size = 'small' }) => {
  const theme = useTheme();
  const { year, setYear, availableYears } = useYear();

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, ...sx }}>
      <CalendarMonth sx={{ fontSize: 18, color: 'text.secondary' }} />
      <FormControl size={size} variant="outlined">
        <Select
          value={year}
          onChange={(e) => setYear(e.target.value)}
          sx={{
            height: 34,
            minWidth: 88,
            fontSize: '0.85rem',
            fontWeight: 700,
            borderRadius: 2,
            color: year === '2026' ? 'primary.main' : 'warning.main',
            backgroundColor: alpha(theme.palette.background.paper, 0.6),
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: alpha(theme.palette.divider, 0.3),
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
          }}
        >
          {availableYears.map((y) => (
            <MenuItem key={y} value={y} dense>
              <Typography variant="body2" fontWeight={y === year ? 700 : 400}>
                {y}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PageYearSelector;
